import { render, staticRenderFns } from "./ListColsConfig.vue?vue&type=template&id=fdb086ee&scoped=true"
import script from "./ListColsConfig.vue?vue&type=script&lang=js"
export * from "./ListColsConfig.vue?vue&type=script&lang=js"
import style0 from "./ListColsConfig.vue?vue&type=style&index=0&id=fdb086ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb086ee",
  null
  
)

export default component.exports